import { NumberFormatter } from '@/services/NumberFormatter';
import PriceService from '@/services/PriceService';
import { PriceDto } from '@eurogast/hub-client-typescript';
import { UnitDefinition } from '@/services/ProductDeserializer';
import Big from 'big.js';
import { CartItem } from '@/services/cart/model/cart';

export abstract class ProductUtil {
  public static getAmountBySku(shoppingCartItems: CartItem[], sku: string) {
    const item = shoppingCartItems.find((x) => x.sku === sku);
    const unit = this.findItemUnit(item);
    if (item) {
      return NumberFormatter.formatFillQuantity(item.amount) + ' ' + unit.name;
    }
    return '';
  }

  public static getBaseAmountBySku(shoppingCartItems: CartItem[], sku: string) {
    const item = shoppingCartItems.find((x) => x.sku === sku);
    if (item) {
      const unit = this.findItemUnit(item);
      const storageUnit = this.findStorageUnitFor(item);
      if (unit) {
        return NumberFormatter.formatFillQuantity(item.amount * unit.ratio) + ' '
          + (storageUnit ? storageUnit.abbreviation : '');
      }
    }
    return '';
  }

  public static getStoragePriceBySku(shoppingCartItems: CartItem[], sku: string) {
    const item = shoppingCartItems.find((x) => x.sku === sku);
    if (!item || !item.product) {
      return '';
    }
    const bulkPrice = this.findPriceFor(item, 1);
    const storageUnit = this.findStorageUnitFor(item);
    return NumberFormatter.formatStoragePrice(bulkPrice, storageUnit);
  }

  public static getSumBySku(shoppingCartItems: CartItem[], sku: string): string {
    const item = shoppingCartItems.find((x) => x.sku === sku);
    const formatted = NumberFormatter.formatPrice(this.findTotalPriceFor(item));
    return formatted ? `${formatted}*` : '';
  }

  public static findTotalPriceFor(item: CartItem): Big {
    const bulkPrice = this.findPriceFor(item, item.amount);
    return PriceService.findFinalPrice(bulkPrice, item.amount, this.findItemUnit(item));
  }

  private static findPriceFor(item: CartItem, actualQuantity: number): PriceDto {
    if (!item || !item.product) {
      return null;
    }
    return PriceService.findBestBulkPrice(item.product.bulkPrices, actualQuantity, this.findItemUnit(item));
  }

  private static findStorageUnitFor(item): UnitDefinition {
    return item.product.units.find((candidate) => candidate.isStorageUnit);
  }

  private static findItemUnit(item: CartItem): UnitDefinition {
    if (!item || !item.product) {
      return null;
    }
    return item.product.units.find((candidate) => candidate.abbreviation === item.unitAbbreviation);
  }
}
